import { createApi } from "@reduxjs/toolkit/query/react";
import { reducerPaths } from "../../app/reducerPaths";
import { baseQueryWithAuth } from "../methods/baseQueryWithAuth";

export const upcomingCarsApi = createApi({
  reducerPath: reducerPaths.upcomingCarsApi, // Unique key in Redux store
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    setAutoBid: builder.mutation({
      query: ({ payload }) => {
        return {
          method: "POST",
          url: `/dealer/setautobid`,
          body: payload
        }
      }
    }),
    setAutoBidBuyNow: builder.mutation({
      query: ({ payload }) => {
        return {
          method: "POST",
          url: `/dealer/SetAutoBidBuyNow`,
          body: payload
        }
      }
    }),
    getAutoBidHistory: builder.query({
      query: ({ Vehicle_Id }) => {
        return {
          url: `/dealer/AutoBidHistory/${Vehicle_Id}`,
          method: "GET"
        }
      }
    }),
    fetchFilterOptions: builder.query({
      query: ({ endpoint }) => ({
        url: endpoint,
      }),
    }),
    fetchModelOptions: builder.query({
      query: ({ endpoint, payload }) => ({
        method: "POST",
        url: endpoint,
        body: payload,
      }),
    }),
    getVehicleMakes: builder.query({
      query: ({ method }) => {
        return {
          url: `/get-year-make`,
          method: "GET",
        };
      },
    }),
    getVehicleModels: builder.mutation({
      query: ({ method, payload }) => {
        return {
          url: `/get-model`,
          method: method || "POST",
          body: payload,
        };
      },
    }),
    addtoWatchList: builder.query({
      query: ({ Vehicle_Id }) => {
        return {
          url: `/addtowatchlist/${Vehicle_Id}`,
          method: "GET"
        }
      }
    }),
    fetchOwnCars: builder.query({
      query: ({ page, per_page, params }) => ({
        method: "GET",
        // url: `/myGarage/Seller/UpcomingCars?page=${page}&per_page=${per_page}`
        url: `/myGarage/Seller/FutureAuctions?page=${page}&per_page=${per_page}`,
        params: params || {}
      }),
    }),
    fetchOtherCars: builder.query({
      query: ({ page, per_page, params }) => ({
        method: "GET",
        // url: `/myGarage/Seller/UpcomingCars?page=${page}&per_page=${per_page}`
        url: `/myGarage/Dealer/UpcomingCars?page=${page}&per_page=${per_page}`,
        params: params || {}
      }),
    }),
  }),
});

export const {
  useSetAutoBidMutation,
  useSetAutoBidBuyNowMutation,
  useFetchFilterOptionsQuery,
  useFetchModelOptionsQuery,
  useFetchOwnCarsQuery,
  useFetchOtherCarsQuery,
  useGetVehicleMakesQuery,
  useGetVehicleModelsMutation,
  useAddtoWatchListQuery,
  useLazyFetchOwnCarsQuery,
  useLazyFetchOtherCarsQuery,
  useLazyGetVehicleMakesQuery,
  useLazyGetAutoBidHistoryQuery,
  useLazyAddtoWatchListQuery
} = upcomingCarsApi;